<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style>
    body{
        height:100vh;
    }

    #app{
        height:100vh;
    }

    .form-control:focus {
        box-shadow: none !important;
    }
    .btn:focus{
        box-shadow: none !important;
    }

    .modal.show{
        display: block;
    }

    .dropdown.v-select{
        width: 100%;
    }

    .dropdown.v-select .dropdown-toggle{
        border-radius: 0.2rem;
        border-color: rgb(206, 212, 218);
    }

    .dropdown.v-select .clear{
        bottom: 3px;
    }

    .dropdown.v-select.open .dropdown-toggle{
        border-color: #80bdff;
        border-radius: 0.2rem 0.2rem 0 0;
        border-bottom-color: rgba(0,0,0,0);
    }

    .dropdown.v-select .open-indicator{
        bottom: 3px;
    }

    .dropdown.v-select.open .open-indicator{
        bottom: -2px;
    }

    .dropdown.v-select input{
        height: 28px;
        padding: 4px 8px;
        font-size: 14px;
    }

    .dropdown.v-select .selected-tag{
        font-size: 13px;
        color: #495057;
        padding: 0 0 4px 0;
    }

    .dropdown.v-select input:focus{
        border-color: #80bdff;
        font-size: 13px !important;
        height: 28px !important;
    }

    .dropdown.v-select .dropdown-menu{
        border-color: #80bdff;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue